<template lang="html">
    <div>
        <div class="pane" :class="{ 'pane--on': open }">
            <div class="mini-cart">
                <div class="mini-cart__header">
                    <p class="mini-cart__title">
                        Lagt i kurv
                        <svg
                            class="bi mini-cart__title-icon"
                            width="14"
                            height="14"
                            fill="currentColor"
                        >
                            <use
                                href="../static/bi-sprite.svg#checkmark-circled"
                            ></use>
                        </svg>
                    </p>
                    <button @click="closeCart" class="mini-cart__close">
                        <svg width="21" height="21" fill="currentColor">
                            <use href="../static/bi-sprite.svg#x-light" />
                        </svg>
                    </button>
                </div>
                <div class="mini-cart__content" ref="miniCartContent">
                    <div
                        class="mini-cart__product js-cart-item"
                        v-if="productData"
                    >
                        <div class="row">
                            <div class="col-5 col-md-7 d-flex">
                                <img
                                    v-if="productData.image"
                                    class="mini-cart__product-image"
                                    :src="productData.image.url"
                                />
                            </div>
                            <div
                                class="col-7 col-md-5 d-flex flex-column justify-content-center"
                            >
                                <p
                                    class="mini-cart__text mini-cart__product-name"
                                    v-if="productData.name"
                                >
                                    {{ productData.name }}
                                </p>
                                <p
                                    class="mini-cart__text mini-cart__product-detail"
                                    v-if="productData.primarySpec"
                                >
                                    {{ productData.primarySpec }}
                                </p>
                                <p
                                    class="mini-cart__text mini-cart__product-price"
                                    v-if="productData.price"
                                >
                                    <b>{{ productData.quantity }} stk.</b> lagt
                                    i kurv
                                </p>
                                <!-- <p
                                    class="mini-cart__text mini-cart__product-price"
                                    v-if="productData.price"
                                >
                                    {{ productData.price }}
                                    <small>{{ productData.currency }}</small>
                                </p> -->
                            </div>
                        </div>
                    </div>
                    <div class="mini-cart__related">
                        <h2 class="mini-cart__related-header">
                            {{ dict["relaterede produkter"] }}
                        </h2>
                        <div
                            class="mini-cart__related-swiper swiper"
                            ref="relatedProducts"
                        >
                            <div
                                class="swiper-button-prev swiper-button-prev--secondary mini-cart__swiper-prev"
                            >
                                <svg
                                    class="bi"
                                    width="40"
                                    height="40"
                                    fill="currentColor"
                                >
                                    <use
                                        href="/static/bi-sprite.svg?v=30#chevron-left"
                                    ></use>
                                </svg>
                            </div>
                            <div
                                class="swiper-button-next swiper-button-next--secondary mini-cart__swiper-next"
                            >
                                <svg
                                    class="bi"
                                    width="40"
                                    height="40"
                                    fill="currentColor"
                                >
                                    <use
                                        href="/static/bi-sprite.svg?v=30#chevron-right"
                                    ></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mini-cart__footer">
                    <div class="mini-cart__cta">
                        <div>
                            <a
                                href="#"
                                class="btn btn-cta btn-cta--secondary btn-block"
                                @click.prevent="closeCart()"
                            >
                                <span>{{ dict["shop videre"] }}</span>
                            </a>
                        </div>
                        <div>
                            <a
                                :href="cartpage"
                                class="btn btn-cta btn-cta--tertiary btn-block"
                            >
                                <span class="d-none d-sm-inline">{{
                                    dict["fortsæt til kurv"]
                                }}</span>
                                <span class="d-sm-none">{{
                                    dict["til kurv"]
                                }}</span>
                            </a>
                        </div>
                    </div>
                    <div class="mini-cart__notification" v-if="remainingText">
                        <span class="mini-cart__notification-icon">!</span>
                        <div v-html="remainingText"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- panel dimmer -->
        <div class="dimmer dimmer--pane" @click="closeCart()"></div>
    </div>
</template>

<script>
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import Vue from "vue";
import axios from "../vue/store/axios";
import MiniCartTable from "./components/MiniCartTable";

export default Vue.extend({
    name: "MiniCart",
    components: {
        MiniCartTable,
    },
    props: [],
    data() {
        return {
            contextId: window.umbracoContext.id,
            cartpage: window.umbracoContext.cartpage,
            dict: {},
            productData: {},
            giftcardsData: {},
            remainingText: null,
            open: false,
            loading: true,
        };
    },
    created() {
        this.update(false, null, null);
    },
    mounted() {
        const relatedProductsEle = document.querySelector(
            ".js-related-products"
        );
        if (relatedProductsEle != null) {
            const clonedEle = relatedProductsEle.cloneNode(true);
            clonedEle.className = "";
            clonedEle.classList.add("swiper-wrapper");
            const swiperSlides = clonedEle.querySelectorAll(
                ".js-related-product"
            );
            swiperSlides.forEach((slide) => {
                slide.className = "";
                slide.classList.add("swiper-slide");
            });
            const mcRelatedProductsEle = this.$refs.relatedProducts;
            mcRelatedProductsEle.prepend(clonedEle);

            const s = new Swiper(mcRelatedProductsEle, {
                modules: [Navigation],
                navigation: {
                    prevEl: ".mini-cart__swiper-prev",
                    nextEl: ".mini-cart__swiper-next",
                },
                spaceBetween: 0,
                slidesPerView: 1.5,
                breakpoints: {
                    391: {
                        slidesPerView: 2.75,
                    },
                    769: {
                        slidesPerView: 2.25,
                    },
                },
            });
        }

        window.addEventListener("cart-update", (e) => {
            this.update(true, e.detail.productId, e.detail.quantity);
        });
        window.addEventListener("cart-show", () => {
            this.open = true;
            document.body.classList.add("modal-open");
        });
    },
    methods: {
        update(openPanel, productId, quantity) {
            this.loading = true;
            axios
                .get("/cart/GetMiniCart", {
                    params: {
                        contextId: this.contextId,
                        productId: productId,
                        quantity: quantity,
                    },
                })
                .then((result) => {
                    this.productData = result.product;
                    if (this.productData != null) {
                        this.productData.image = result.productImage;
                        this.productData.price = result.productPrice;
                        this.productData.currency = result.currency;
                        this.productData.quantity = quantity;
                        this.remainingText = result.remainingText;
                        this.dict = result.dict;

                        const contentEle = this.$refs.miniCartContent;
                        if (contentEle) {
                            contentEle.scrollTo({
                                top: 0,
                            });
                        }

                        this.open = openPanel;
                        if (openPanel) {
                            document.body.classList.add("modal-open");
                        }
                    }
                    updateCounter(result.totalCartQuantity);

                    // let _result = result.data || result;

                    // let _productData = {
                    //     products: _result.cartLines,
                    //     deliveryMethodText: _result.deliveryMethodText,
                    //     deliveryMethodPrice: _result.deliveryMethodPrice,
                    //     deliveryDiscount: _result.deliveryDiscount,
                    //     totalText: _result.totalText,
                    //     totalPrice: _result.totalPrice,
                    //     totalPriceExcludingGiftcard:
                    //         _result.totalPriceExcludingGiftcard,
                    //     totalPriceWithTaxExcludingGiftcard:
                    //         _result.totalPriceWithTaxExcludingGiftcard,
                    //     cartlink: window.umbracoContext.cartpage,
                    //     totalPriceIncludingVat: _result.totalPriceIncludingVat,
                    //     priceIncludingVat: _result.priceIncludingVat,
                    //     giftcardImage: _result.giftcardImage,
                    // };

                    // let _giftcardData = {
                    //     giftcards: _result.giftCardLines,
                    // };

                    // this.productsData = _productData;
                    // this.giftcardsData = _giftcardData;
                    // this.dict = _result.dict;
                    // this.open = openPanel;
                    // if (openPanel) {
                    //     document.body.classList.add("modal-open");
                    // }
                    // this.loading = false;
                    // let count = result.cartLines.reduce(
                    //     (a, b) => a + (b.quantity || 0),
                    //     0
                    // );
                    //updateCounter(count);
                });
        },
        closeCart() {
            this.open = false;
            document.body.classList.remove("modal-open");
        },
    },
    computed: {},
});

const updateCounter = (count) =>
    (document.getElementById("productCount").innerHTML =
        count > 0 ? count : "");
</script>
